"use client"

// ============================================
// PO DETAILS SECTION COMPONENT
// ============================================
import { FaFileInvoice, FaEdit, FaTrash, FaChevronDown, FaChevronUp, FaSave, FaSpinner } from "react-icons/fa"
import { BRAND_OPTIONS, CEMENT_SITE_TYPES } from "./shared"

const PODetailsSection = ({
  selectedUser,
  loading,
  poList,
  userCodes,
  expandedPOs,
  editingPO,
  editedPOData,
  newPOForm,
  formErrors,
  // Handlers
  togglePOExpansion,
  startEditingPO,
  cancelEditingPO,
  handleEditedPOChange,
  handleEditedPOSiteChange,
  saveEditedPO,
  deletePO,
  handleNewPOChange,
  handleNewPOSiteChange,
  handleSubmitNewPO,
  handleSelectPO,
}) => {
  const renderPOInfo = (po, isEditing) => {
    if (isEditing) {
      return (
        <div className="po-edit-form">
          <div className="edit-grid">
            <div className="form-group">
              <label>Basic Price</label>
              <input
                type="number"
                value={editedPOData.basicPrice}
                onChange={(e) => handleEditedPOChange("basicPrice", e.target.value)}
                placeholder="Enter Basic Price"
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="form-group">
              <label>GST Percentage</label>
              <input
                type="number"
                value={editedPOData.gstPercentage}
                onChange={(e) => handleEditedPOChange("gstPercentage", e.target.value)}
                placeholder="Enter GST %"
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="form-group">
              <label>Calculated GST</label>
              <input
                type="number"
                value={
                  editedPOData.basicPrice && editedPOData.gstPercentage
                    ? (Number(editedPOData.basicPrice) * Number(editedPOData.gstPercentage)) / 100
                    : ""
                }
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Total Billing Price/Bag</label>
              <input
                type="number"
                value={editedPOData.totalPrice}
                onChange={(e) => handleEditedPOChange("totalPrice", e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="form-group">
              <label>Packaging</label>
              <input
                type="text"
                value={editedPOData.packaging}
                onChange={(e) => handleEditedPOChange("packaging", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>GST No</label>
              <input
                type="text"
                value={editedPOData.gstNo}
                onChange={(e) => handleEditedPOChange("gstNo", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>PAN No</label>
              <input
                type="text"
                value={editedPOData.panNo}
                onChange={(e) => handleEditedPOChange("panNo", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Payment Terms</label>
              <input
                type="text"
                value={editedPOData.paymentTerms}
                onChange={(e) => handleEditedPOChange("paymentTerms", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Billing Address</label>
              <input
                type="text"
                value={editedPOData.billingAddress}
                onChange={(e) => handleEditedPOChange("billingAddress", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Site Address</label>
              <input
                type="text"
                value={editedPOData.siteAddress?.address || ""}
                onChange={(e) => handleEditedPOSiteChange("address", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Site State</label>
              <input
                type="text"
                value={editedPOData.siteAddress?.state || ""}
                onChange={(e) => handleEditedPOSiteChange("state", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Site Pincode</label>
              <input
                type="text"
                value={editedPOData.siteAddress?.pincode || ""}
                onChange={(e) => handleEditedPOSiteChange("pincode", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Contact Person</label>
              <input
                type="text"
                value={editedPOData.contactPerson}
                onChange={(e) => handleEditedPOChange("contactPerson", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Contact Mobile</label>
              <input
                type="text"
                value={editedPOData.contactMobile}
                onChange={(e) => handleEditedPOChange("contactMobile", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Delivery Schedule</label>
              <input
                type="text"
                value={editedPOData.deliverySchedule}
                onChange={(e) => handleEditedPOChange("deliverySchedule", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>End Use of Cement</label>
              <input
                type="text"
                value={editedPOData.endUse}
                onChange={(e) => handleEditedPOChange("endUse", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Category</label>
              <input
                type="text"
                value={editedPOData.category}
                onChange={(e) => handleEditedPOChange("category", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={editedPOData.email}
                onChange={(e) => handleEditedPOChange("email", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>TPC Code</label>
              <input
                type="text"
                value={editedPOData.tpcCode}
                onChange={(e) => handleEditedPOChange("tpcCode", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Brand</label>
              <select value={editedPOData.brand} onChange={(e) => handleEditedPOChange("brand", e.target.value)}>
                <option value="">--Select Brand--</option>
                {BRAND_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                value={editedPOData.companyName}
                onChange={(e) => handleEditedPOChange("companyName", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Quantity Type (Bags/MT)</label>
              <input
                type="text"
                value={editedPOData.quantityType}
                onChange={(e) => handleEditedPOChange("quantityType", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Rate</label>
              <input
                type="number"
                value={editedPOData.rate}
                onChange={(e) => handleEditedPOChange("rate", e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="form-group">
              <label>Status</label>
              <select value={editedPOData.status} onChange={(e) => handleEditedPOChange("status", e.target.value)}>
                <option value="active">Active</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="expired">Expired</option>
              </select>
            </div>
          </div>

          <div className="form-actions">
            <button className="btn btn-secondary" onClick={cancelEditingPO}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={saveEditedPO}>
              <FaSave /> Save Changes
            </button>
          </div>
        </div>
      )
    }

    return (
      <div className="po-info-grid">
        <div className="info-row">
          <label>PO Number:</label>
          <span>{po.poNumber || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Quantity:</label>
          <span>{po.quantity || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Grade:</label>
          <span>{po.grade || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Transportation Type:</label>
          <span>{po.cementSiteType || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Site Address:</label>
          <span>{po.siteAddress?.address || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Site State:</label>
          <span>{po.siteAddress?.state || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Site Pincode:</label>
          <span>{po.siteAddress?.pincode || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Creation Date:</label>
          <span>
            {po.creationDate || po.timestamp ? new Date(po.creationDate || po.timestamp).toLocaleDateString() : "N/A"}
          </span>
        </div>
        <div className="info-row">
          <label>Brand:</label>
          <span>{po.brand || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Code ID:</label>
          <span>{po.code || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Company Name:</label>
          <span>{po.companyName || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Quantity Type:</label>
          <span>{po.quantityType || "N/A"}</span>
        </div>
        <div className="info-row">
          <label>Rate:</label>
          <span>{po.rate || "N/A"}</span>
        </div>
      </div>
    )
  }

  const getStatusClass = (status) => {
    const statusMap = {
      active: "status-active",
      Pending: "status-pending",
      Completed: "status-completed",
      expired: "status-expired",
    }
    return statusMap[status] || ""
  }

  const renderNewPOForm = () => (
    <div className="new-po-form-section">
      <h3>
        <FaFileInvoice /> Add New PO
      </h3>
      <div className="new-po-form">
        <div className="form-group">
          <label>Code</label>
          <select value={newPOForm.code} onChange={(e) => handleNewPOChange("code", e.target.value)}>
            <option value="">--Select Code--</option>
            {userCodes.map((code) => (
              <option key={code.id} value={code.codeID}>
                {code.codeID}
              </option>
            ))}
          </select>
          {formErrors.code && <span className="error-text">{formErrors.code}</span>}
        </div>

        <div className="form-group">
          <label>PO ID</label>
          <select value={newPOForm.poNumber} onChange={(e) => handleSelectPO(e.target.value)}>
            <option value="">--Select PO ID--</option>
            {poList.map((po) => (
              <option key={po.id} value={po.id}>
                {po.id}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Grade</label>
          <input
            type="text"
            value={newPOForm.grade}
            onChange={(e) => handleNewPOChange("grade", e.target.value)}
            placeholder="Enter grade"
          />
          {formErrors.grade && <span className="error-text">{formErrors.grade}</span>}
        </div>

        <div className="form-group">
          <label>Transportation Type</label>
          <select
            value={newPOForm.cementSiteType || ""}
            onChange={(e) => handleNewPOChange("cementSiteType", e.target.value)}
          >
            <option value="">--Select Type--</option>
            {CEMENT_SITE_TYPES.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Quantity</label>
          <input
            type="number"
            value={newPOForm.quantity}
            onChange={(e) => handleNewPOChange("quantity", e.target.value)}
            placeholder="Enter quantity"
            onWheel={(e) => e.target.blur()}
          />
          {formErrors.quantity && <span className="error-text">{formErrors.quantity}</span>}
        </div>

        <div className="form-group">
          <label>Rate</label>
          <input
            type="number"
            value={newPOForm.rate}
            onChange={(e) => handleNewPOChange("rate", e.target.value)}
            placeholder="Enter rate"
            onWheel={(e) => e.target.blur()}
          />
          {formErrors.rate && <span className="error-text">{formErrors.rate}</span>}
        </div>

        <div className="form-group">
          <label>Site Address</label>
          <input
            type="text"
            value={newPOForm.siteAddress.address}
            onChange={(e) => handleNewPOSiteChange("address", e.target.value)}
            placeholder="Enter site address"
          />
          {formErrors.address && <span className="error-text">{formErrors.address}</span>}
        </div>

        <div className="form-group">
          <label>Site State</label>
          <input
            type="text"
            value={newPOForm.siteAddress.state}
            onChange={(e) => handleNewPOSiteChange("state", e.target.value)}
            placeholder="Enter site state"
          />
          {formErrors.state && <span className="error-text">{formErrors.state}</span>}
        </div>

        <div className="form-group">
          <label>Site Pincode</label>
          <input
            type="text"
            value={newPOForm.siteAddress.pincode}
            onChange={(e) => handleNewPOSiteChange("pincode", e.target.value)}
            placeholder="Enter site pincode"
          />
          {formErrors.pincode && <span className="error-text">{formErrors.pincode}</span>}
        </div>

        <div className="form-group">
          <label>Basic Price</label>
          <input
            type="number"
            value={newPOForm.basicPrice}
            onChange={(e) => handleNewPOChange("basicPrice", e.target.value)}
            placeholder="Enter Basic Price"
            onWheel={(e) => e.target.blur()}
          />
          {formErrors.basicPrice && <span className="error-text">{formErrors.basicPrice}</span>}
        </div>

        <div className="form-group">
          <label>GST Percentage</label>
          <input
            type="number"
            value={newPOForm.gstPercentage}
            onChange={(e) => handleNewPOChange("gstPercentage", e.target.value)}
            placeholder="Enter GST %"
            onWheel={(e) => e.target.blur()}
          />
          {formErrors.gstPercentage && <span className="error-text">{formErrors.gstPercentage}</span>}
        </div>

        <div className="form-group">
          <label>Calculated GST</label>
          <input
            type="number"
            value={
              newPOForm.basicPrice && newPOForm.gstPercentage
                ? (Number(newPOForm.basicPrice) * Number(newPOForm.gstPercentage)) / 100
                : ""
            }
            readOnly
          />
        </div>

        <div className="form-group">
          <label>Total Billing Price/Bag</label>
          <input
            type="number"
            value={newPOForm.totalPrice}
            onChange={(e) => handleNewPOChange("totalPrice", e.target.value)}
            placeholder="Enter total price"
            onWheel={(e) => e.target.blur()}
          />
          {formErrors.totalPrice && <span className="error-text">{formErrors.totalPrice}</span>}
        </div>

        <div className="form-group">
          <label>Packaging</label>
          <input
            type="text"
            value={newPOForm.packaging}
            onChange={(e) => handleNewPOChange("packaging", e.target.value)}
            placeholder="Enter packaging"
          />
        </div>

        <div className="form-group">
          <label>GST Number</label>
          <input
            type="text"
            value={newPOForm.gstNo}
            onChange={(e) => handleNewPOChange("gstNo", e.target.value)}
            placeholder="Enter GST no"
          />
          {formErrors.gstNo && <span className="error-text">{formErrors.gstNo}</span>}
        </div>

        <div className="form-group">
          <label>PAN Number</label>
          <input
            type="text"
            value={newPOForm.panNo}
            onChange={(e) => handleNewPOChange("panNo", e.target.value)}
            placeholder="Enter PAN no"
          />
          {formErrors.panNo && <span className="error-text">{formErrors.panNo}</span>}
        </div>

        <div className="form-group">
          <label>Payment Terms</label>
          <input
            type="text"
            value={newPOForm.paymentTerms}
            onChange={(e) => handleNewPOChange("paymentTerms", e.target.value)}
            placeholder="Enter payment terms"
          />
          {formErrors.paymentTerms && <span className="error-text">{formErrors.paymentTerms}</span>}
        </div>

        <div className="form-group">
          <label>Billing Address</label>
          <input
            type="text"
            value={newPOForm.billingAddress}
            onChange={(e) => handleNewPOChange("billingAddress", e.target.value)}
            placeholder="Enter billing address"
          />
          {formErrors.billingAddress && <span className="error-text">{formErrors.billingAddress}</span>}
        </div>

        <div className="form-group">
          <label>Contact Person</label>
          <input
            type="text"
            value={newPOForm.contactPerson}
            onChange={(e) => handleNewPOChange("contactPerson", e.target.value)}
            placeholder="Enter contact person"
          />
          {formErrors.contactPerson && <span className="error-text">{formErrors.contactPerson}</span>}
        </div>

        <div className="form-group">
          <label>Contact Mobile</label>
          <input
            type="text"
            value={newPOForm.contactMobile}
            onChange={(e) => handleNewPOChange("contactMobile", e.target.value)}
            placeholder="Enter contact mobile"
          />
          {formErrors.contactMobile && <span className="error-text">{formErrors.contactMobile}</span>}
        </div>

        <div className="form-group">
          <label>Delivery Schedule</label>
          <input
            type="text"
            value={newPOForm.deliverySchedule}
            onChange={(e) => handleNewPOChange("deliverySchedule", e.target.value)}
            placeholder="Enter delivery schedule"
          />
        </div>

        <div className="form-group">
          <label>End Use of Cement</label>
          <input
            type="text"
            value={newPOForm.endUse}
            onChange={(e) => handleNewPOChange("endUse", e.target.value)}
            placeholder="Enter end use"
          />
        </div>

        <div className="form-group">
          <label>Category</label>
          <input
            type="text"
            value={newPOForm.category}
            onChange={(e) => handleNewPOChange("category", e.target.value)}
            placeholder="Enter category"
          />
          {formErrors.category && <span className="error-text">{formErrors.category}</span>}
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={newPOForm.email}
            onChange={(e) => handleNewPOChange("email", e.target.value)}
            placeholder="Enter email"
          />
          {formErrors.email && <span className="error-text">{formErrors.email}</span>}
        </div>

        <div className="form-group">
          <label>TPC Code</label>
          <input
            type="text"
            value={newPOForm.tpcCode}
            onChange={(e) => handleNewPOChange("tpcCode", e.target.value)}
            placeholder="Enter TPC code"
          />
        </div>

        <div className="form-group">
          <label>Brand</label>
          <select value={newPOForm.brand} onChange={(e) => handleNewPOChange("brand", e.target.value)}>
            <option value="">--Select Brand--</option>
            {BRAND_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Company Name</label>
          <input
            type="text"
            value={newPOForm.companyName}
            onChange={(e) => handleNewPOChange("companyName", e.target.value)}
            placeholder="Enter company name"
          />
          {formErrors.companyName && <span className="error-text">{formErrors.companyName}</span>}
        </div>

        <div className="form-group">
          <label>Quantity Type (Bags/MT)</label>
          <input
            type="text"
            value={newPOForm.quantityType}
            onChange={(e) => handleNewPOChange("quantityType", e.target.value)}
            placeholder="Enter quantity type"
          />
          {formErrors.quantityType && <span className="error-text">{formErrors.quantityType}</span>}
        </div>

        <div className="form-actions">
          <button className="btn btn-primary btn-lg" onClick={handleSubmitNewPO} disabled={loading}>
            {loading ? (
              <>
                <FaSpinner className="spinner" /> Submitting...
              </>
            ) : (
              <>
                <FaSave /> Add New PO
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )

  return (
    <div className="po-details-tab">
      <div className="section-header">
        <FaFileInvoice className="section-icon" />
        <h2>Purchase Order Details</h2>
      </div>
      <p className="section-subtitle">Manage PO details for {selectedUser.username || selectedUser.email}</p>

      <div className="po-details-container">
        <div className="po-cards-section">
          <h3>User POs ({poList.length})</h3>

          {loading ? (
            <div className="loading-state">
              <FaSpinner className="spinner" /> Loading POs...
            </div>
          ) : poList.length === 0 ? (
            <div className="empty-state">
              <FaFileInvoice className="empty-icon" />
              <p>No POs found for this user.</p>
            </div>
          ) : (
            <div className="po-cards">
              {poList.map((po) => (
                <div key={po.id} className={`po-card ${expandedPOs[po.id] ? "expanded" : ""}`}>
                  <div className="po-header" onClick={() => togglePOExpansion(po.id)}>
                    <div className="po-title">
                      <span className="po-number">PO: {po.poNumber}</span>
                      <span className={`po-status ${getStatusClass(po.status)}`}>{po.status}</span>
                    </div>
                    <div className="po-actions">
                      <button
                        className="icon-btn edit"
                        onClick={(e) => {
                          e.stopPropagation()
                          startEditingPO(po)
                        }}
                        title="Edit PO"
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="icon-btn delete"
                        onClick={(e) => {
                          e.stopPropagation()
                          deletePO(po.id)
                        }}
                        title="Delete PO"
                      >
                        <FaTrash />
                      </button>
                      {expandedPOs[po.id] ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  </div>

                  {expandedPOs[po.id] && <div className="po-details">{renderPOInfo(po, editingPO === po.id)}</div>}
                </div>
              ))}
            </div>
          )}
        </div>

        {renderNewPOForm()}
      </div>
    </div>
  )
}

export default PODetailsSection
